import { render, staticRenderFns } from "./AssignRulesPlantilla.vue?vue&type=template&id=713004fe"
import script from "./AssignRulesPlantilla.vue?vue&type=script&lang=js"
export * from "./AssignRulesPlantilla.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports